module.exports = __webpack_public_path__ + "img/product_slider_title.733e98c.webp";